(function favoritesDefinition() {
    'use strict';
    angular.module('Entities')
        .service('favoritesService', [
            'restUrlBuilder', function favoritesService(restUrlBuilder) {

                this.getFavorites = function getFavorites(name, page, itemsPerPage, orderBy, asc) {
                    var params = { Name: name, ItemPerPage: itemsPerPage, Page: page, OrderBy: orderBy, OrderAscendent: asc };

                    return restUrlBuilder.all('Favourites').get({ params: params });
                };

                this.exists = function exists(id, type) {
                    var params = { Id: id, Type: type }

                    return restUrlBuilder.one('Favourites/Exists', id).get({ params: params });
                };

                this.addFavorite = function addFavorite(id, type) {
                    var params = { Id: id, Type: type }

                    return restUrlBuilder.all('Favourites')
                        .post(params);
                };

                this.removeFavorite = function removeFavorite(id, type) {
                    var params = { Id: id, Type: type }

                    return restUrlBuilder.all('Favourites')
                        .delete({ params: params });
                };
            }
        ]);
})();